"use client";

import { useState } from "react";
import { Icon } from "@/components/formatters/MXPIcon";
import useMouse from "../../utils/hooks/useMouse";
import { darkTextureWrapper, colorSettingDetection } from "../../utils/functions";
export interface BlogOption {
  label: string;
  url: string;
}
export interface BlogSwitcherProps {
  header: string;
  headerElement?: "h1" | "h2";
  dropdownTitle: string;
  dropdownOptions: BlogOption[];
  selection: string;
  isWrapped?: boolean;
  presetTheme?: "t2-theme-one" | "t2-theme-two" | "t2-theme-three" | "t2-theme-four" | "t2-theme-five" | "t2-theme-six" | "t2-theme-seven";
  setSelection: (val: string) => void;
  onNavigate?: (url: string) => void;
}
export const BlogSwitcher = ({
  header,
  headerElement = "h1",
  dropdownTitle,
  dropdownOptions,
  selection,
  isWrapped = true,
  presetTheme = "t2-theme-one",
  setSelection,
  onNavigate
}: BlogSwitcherProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    mouse
  } = useMouse();
  const colorSetting = colorSettingDetection(presetTheme || "");
  const mainClasses = `${presetTheme || ""} ${colorSetting} max-lg:flex-col max-lg:pt-12`;
  const componentStyles = darkTextureWrapper(presetTheme || "");
  const wrapperClasses = `${isWrapped ? "w-full px-5 lg:px-20 m-auto max-w-[1440px] t2-container" : ""}`;
  const handleClick = (option: BlogOption) => {
    setSelection(option.label);
    setIsOpen(false);
    if (onNavigate) {
      onNavigate(option.url);
    } else {
      // eslint-disable-next-line react-hooks/immutability
      window.location.href = option.url;
    }
  };
  const renderDropdowns = () => {
    return dropdownOptions?.map((option_0, index) => {
      return <li key={`${option_0.label}-${index}`} tabIndex={mouse ? undefined : 0} className="list-none cursor-pointer border-b border-r border-l border-gray-m2 w-[200px] p-2.5 text-black bg-white hover:bg-gray-m1" onClick={() => handleClick(option_0)} onKeyDown={e => {
        if (e && e.key === "Enter") {
          handleClick(option_0);
        }
      }}>
          {option_0.label}
        </li>;
    });
  };
  return <div className={mainClasses} style={componentStyles}>
      <div className={wrapperClasses}>
        <div className="flex justify-between py-8 max-xl:flex-col">
          {header && (headerElement === "h1" ? <h1 className="border-l-10 border-blue-trmb !pl-8 mt-2.5 text-gray-m9 text-7xl max-sm:text-5xl font-extrabold leading-tight tracking-tight max-xl:mb-8 t2-dark:text-white">
                {header}
              </h1> : <h2 className="border-l-10 border-blue-trmb !pl-8 mt-2.5 text-gray-m9 text-7xl max-sm:text-5xl font-extrabold leading-tight tracking-tight max-xl:mb-8 t2-dark:text-white">
                {header}
              </h2>)}
          <div className="mt-10 max-xl:relative max-xl:mt-0 cursor-pointer">
            {dropdownOptions?.length > 0 && <div className={isOpen ? `flex text-base border border-gray-m2 w-[200px] rounded-t-lg p-2.5 justify-between` : `flex text-base border border-gray-m2 w-[200px] rounded-lg p-2.5 justify-between`} tabIndex={mouse ? undefined : 0} onClick={() => setIsOpen(!isOpen)} onKeyDown={e_0 => {
            if (e_0 && e_0.key === "Enter") setIsOpen(!isOpen);
          }}>
                {selection ? selection : dropdownTitle}
                <Icon type={"t2u-chevron-right"} rotateDeg="90" size={12} label="Toggle Blog Switcher Dropdown" className="relative top-1.5 right-4" />
              </div>}
            {isOpen && dropdownOptions?.length > 0 && <ul className="absolute p-0 m-0">{renderDropdowns()}</ul>}
          </div>
        </div>
      </div>
    </div>;
};